// Polling Agent (Interview Agent) Actions
import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';
import { dedupedGet } from '../../utils/api/dedupedFetch';

export const GET_POLLING_AGENTS = 'GET_POLLING_AGENTS';
export const GET_POLLING_AGENTS_SUCCESS = 'GET_POLLING_AGENTS_SUCCESS';
export const GET_POLLING_AGENTS_FAIL = 'GET_POLLING_AGENTS_FAIL';
export const GET_POLLING_AGENTS_RESET = 'GET_POLLING_AGENTS_RESET';

export const GET_POLLING_AGENT_BY_ID = 'GET_POLLING_AGENT_BY_ID';
export const GET_POLLING_AGENT_BY_ID_SUCCESS = 'GET_POLLING_AGENT_BY_ID_SUCCESS';
export const GET_POLLING_AGENT_BY_ID_FAIL = 'GET_POLLING_AGENT_BY_ID_FAIL';
export const GET_POLLING_AGENT_BY_ID_RESET = 'GET_POLLING_AGENT_BY_ID_RESET';

export const CREATE_POLLING_AGENT = 'CREATE_POLLING_AGENT';
export const CREATE_POLLING_AGENT_SUCCESS = 'CREATE_POLLING_AGENT_SUCCESS';
export const CREATE_POLLING_AGENT_FAIL = 'CREATE_POLLING_AGENT_FAIL';
export const CREATE_POLLING_AGENT_RESET = 'CREATE_POLLING_AGENT_RESET';

export const UPDATE_POLLING_AGENT = 'UPDATE_POLLING_AGENT';
export const UPDATE_POLLING_AGENT_SUCCESS = 'UPDATE_POLLING_AGENT_SUCCESS';
export const UPDATE_POLLING_AGENT_FAIL = 'UPDATE_POLLING_AGENT_FAIL';
export const UPDATE_POLLING_AGENT_RESET = 'UPDATE_POLLING_AGENT_RESET';

export const DELETE_POLLING_AGENT = 'DELETE_POLLING_AGENT';
export const DELETE_POLLING_AGENT_SUCCESS = 'DELETE_POLLING_AGENT_SUCCESS';
export const DELETE_POLLING_AGENT_FAIL = 'DELETE_POLLING_AGENT_FAIL';
export const DELETE_POLLING_AGENT_RESET = 'DELETE_POLLING_AGENT_RESET';

export const GET_VOICES = 'GET_VOICES';
export const GET_VOICES_SUCCESS = 'GET_VOICES_SUCCESS';
export const GET_VOICES_FAIL = 'GET_VOICES_FAIL';
export const GET_VOICES_RESET = 'GET_VOICES_RESET';

// Action Creators
export const getPollingAgents = (params) => ({
  type: GET_POLLING_AGENTS,
  params,
});

export const getPollingAgentsSuccess = (response) => ({
  type: GET_POLLING_AGENTS_SUCCESS,
  response,
});

export const getPollingAgentsFail = (response) => ({
  type: GET_POLLING_AGENTS_FAIL,
  response,
});

export const getPollingAgentsReset = () => ({
  type: GET_POLLING_AGENTS_RESET,
});

export const getPollingAgentByIdReset = () => ({
  type: GET_POLLING_AGENT_BY_ID_RESET,
});

export const createPollingAgentReset = () => ({
  type: CREATE_POLLING_AGENT_RESET,
});

export const updatePollingAgentReset = () => ({
  type: UPDATE_POLLING_AGENT_RESET,
});

export const deletePollingAgentReset = () => ({
  type: DELETE_POLLING_AGENT_RESET,
});

export const getVoicesReset = () => ({
  type: GET_VOICES_RESET,
});

// Thunk Actions
export const getPollingAgentsApi = (data) => {
	return (dispatch) => {
		dispatch(getPollingAgents());
		const paramKey = JSON.stringify(data || {});
		dedupedGet(`pollingAgents:${paramKey}`, () =>
			axios.get(`${config.api.base_url}/polling-agents`, {
				params: data,
				headers: { Authorization: 'Bearer ' + getUserToken() },
			}),
		)
			.then((response) => dispatch(getPollingAgentsSuccess(response.data)))
			.catch((error) => dispatch(getPollingAgentsFail(error.response?.data || error.message)));
	};
};

export const getPollingAgentByIdApi = (id) => {
	return (dispatch) => {
		dispatch({ type: GET_POLLING_AGENT_BY_ID });
		dedupedGet(`pollingAgentById:${id}`, () =>
			axios.get(`${config.api.base_url}/polling-agents/${id}`, {
				headers: { Authorization: 'Bearer ' + getUserToken() },
			}),
		)
			.then((response) => dispatch({ type: GET_POLLING_AGENT_BY_ID_SUCCESS, response: response.data }))
			.catch((error) => dispatch({ type: GET_POLLING_AGENT_BY_ID_FAIL, response: error.response?.data || error.message }));
	};
};

export const createPollingAgentApi = (data) => {
	return (dispatch) => {
		dispatch({ type: CREATE_POLLING_AGENT });
		axios
			.post(`${config.api.base_url}/polling-agents`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const createPollingAgentData = response.data;
				dispatch({ type: CREATE_POLLING_AGENT_SUCCESS, response: createPollingAgentData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: CREATE_POLLING_AGENT_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const updatePollingAgentApi = (id, data) => {
	return (dispatch) => {
		dispatch({ type: UPDATE_POLLING_AGENT });
		axios
			.post(`${config.api.base_url}/polling-agents/${id}`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const updatePollingAgentData = response.data;
				dispatch({ type: UPDATE_POLLING_AGENT_SUCCESS, response: updatePollingAgentData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: UPDATE_POLLING_AGENT_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const deletePollingAgentApi = (id) => {
	return (dispatch) => {
		dispatch({ type: DELETE_POLLING_AGENT });
		axios
			.post(`${config.api.base_url}/polling-agents/delete/${id}`, { id }, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const deletePollingAgentData = response.data;
				dispatch({ type: DELETE_POLLING_AGENT_SUCCESS, response: deletePollingAgentData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: DELETE_POLLING_AGENT_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const getVoicesApi = (params) => {
	return (dispatch) => {
		dispatch({ type: GET_VOICES });
		const paramKey = JSON.stringify(params || {});
		dedupedGet(`voices:${paramKey}`, () =>
			axios.get(`${config.api.base_url}/polling-agents/voices/list`, {
				params,
				headers: { Authorization: 'Bearer ' + getUserToken() },
			}),
		)
			.then((response) => dispatch({ type: GET_VOICES_SUCCESS, response: response.data }))
			.catch((error) => dispatch({ type: GET_VOICES_FAIL, response: error.response?.data || error.message }));
	};
};

// Promise-returning fetcher for the "Created By" filter dropdown.
// Hierarchy enforced by the backend.
export const fetchPollingAgentCreators = () => {
	return axios.get(`${config.api.base_url}/polling-agents/creators`, {
		headers: { Authorization: 'Bearer ' + getUserToken() },
	});
};

